import BaseSelectorReadonlyToInput from "../../../component/Select/BaseSelectorReadonlyToInput";
import PropTypes from 'prop-types';

export const ALERT_ID = {
  PERMANENCE_TIME_ALERT: 'PERMANENCE_TIME_ALERT',
  STOCK_LEVEL_CRITICAL_ALERT: 'STOCK_LEVEL_CRITICAL_ALERT',
  NODE_OFFLINE_ALERT: 'NODE_OFFLINE_ALERTS',
  WORKFLOW_ALERT: 'WORKFLOW_ALERT'
};

export const ALERT_TITLE = {
  PERMANENCE_TIME_ALERT: 'Tempo de permanência',
  STOCK_LEVEL_CRITICAL_ALERT: 'Nível crítico de estoque',
  NODE_OFFLINE_ALERTS: 'Node offline',
  WORKFLOW_ALERT: 'Produto apresentando fluxo incorreto'
}

class AlertTypeSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props, 'friendlyName', 'id');
    this.state = {
      ...this.state,
      title: 'Tipo',
      label: 'label',
      items: [
        {label: ALERT_TITLE.PERMANENCE_TIME_ALERT, id: ALERT_ID.PERMANENCE_TIME_ALERT},
        {label: ALERT_TITLE.STOCK_LEVEL_CRITICAL_ALERT, id: ALERT_ID.STOCK_LEVEL_CRITICAL_ALERT},
        {label: ALERT_TITLE.NODE_OFFLINE_ALERTS, id: ALERT_ID.NODE_OFFLINE_ALERT},
        {label: ALERT_TITLE.WORKFLOW_ALERT, id: ALERT_ID.WORKFLOW_ALERT}
      ]
    };
  };
}

AlertTypeSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.any,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export {AlertTypeSelector};



// WEBPACK FOOTER //
// ./src/pages/Alerts/Select/AlertSelect.js